import { ReactElement, forwardRef } from "react";
import {
  useFormContext,
  UseFormRegister,
  DeepMap,
  FieldValues,
  FieldError,
} from "react-hook-form";
import { Label } from "@/components/ui/label";

import { FormControl } from "./components";

export type InputWrapperProps = {
  name: string;
  label?: string;
  wrapperClassName?: string;
  children: (
    register: UseFormRegister<any> | null,
    errors?: DeepMap<FieldValues, FieldError>
  ) => void;
};

export const InputWrapper = forwardRef<any, InputWrapperProps>((props, ref) => {
  const { name, label, wrapperClassName, children } = props;
  const formCtx = useFormContext();

  return (
    <FormControl ref={ref} className={wrapperClassName}>
      {label !== undefined && (
        <Label htmlFor={name} className="mb-1.5">
          {label}
        </Label>
      )}
      {!!formCtx && !!formCtx.register
        ? (children(
            formCtx.register,
            formCtx.formState.errors
          ) as unknown as ReactElement)
        : (children(null) as unknown as ReactElement)}
    </FormControl>
  );
});
